import { Injectable } from '@angular/core';
import { Http, Headers, ResponseContentType } from '@angular/http';
import { environment } from '../../environments/environment';
import { Router } from '@angular/router';
import { Token } from '../manager/token';
import { map } from 'rxjs/operators'
import { Subject } from 'rxjs';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class ClientInstructionService {
  TokenCls;
  clientInstructionRestriction: Subject<boolean> = new Subject<boolean>();

  constructor(private http: HttpClient, private router: Router) {
    this.TokenCls = new Token(this.router);

  }

  GetAllLookups(ClientId: any): any {
    return this.http.get(environment.ApiUrl + '/api/client-instructions-lookup/' + ClientId);
  }

  GetClientInstructions(ClientId):any {
    return this.http.get(environment.ApiUrl + '/api/client-instructions/client/' + ClientId);
  }

  GetSingleClientInstruction(ClientId, InsId):any {
    return this.http.get(environment.ApiUrl + '/api/client-instructions/client/' + ClientId + '/' + InsId);
  }

  InsertInstruction(formdata):any {

    return this.http.post(environment.ApiUrl + '/api/client-instructions', formdata);
  }

  UpdateInstruction(formdata):any {
    return this.http.put(environment.ApiUrl + '/api/client-instructions', formdata);
  }

  getCountData(ClientId, DataId):any {
    return this.http.get(environment.ApiUrl + '/api/client-instruction-read-by-agent/client/' + ClientId + '/' + DataId)
  }

  InstructionUpload(dataobj): any {
    return this.http.post(environment.ApiUrl + '/api/Client_Instructions_Upload', dataobj);
  }

  downLoadTemplate():any {
    return this.http.get(environment.ApiUrl + '/api/client_instruction_download_template', { responseType: 'blob'})
      .pipe(map(res => {
        return {
          filename: 'InstructionTemplate.xlsx',
          data: res
        };
      }));
  }
  getClientInstructionInformation(ClientId) {
    return this.http.get(environment.ApiUrl + '/api/Client_Instruction_Check_Agent/' + ClientId).pipe(map(res => res));
  }

  getSupervisorClientInstructionInformation(ClientId, Id):any {
    return this.http.get(environment.ApiUrl + '/api/Client-Instructions-InstructionDATA/' + ClientId + '/' + Id).pipe(map(res => res));
  }

  downloadAttachedFile(dataobj:any):any {
    return this.http.post(environment.ApiUrl + '/api/client-instructions-Attachment', dataobj, {responseType: 'blob'} )
      .pipe(map(res => {
        return {
          data: res
        };
      }))
  }

  getCountOfAcknowledgement(ClientId, id):any {
    return this.http.get(environment.ApiUrl + '/api/client-instruction-Acnowledgment-Count/client/' + ClientId + '/' + id).pipe(map(res => res));
  }

  exportToExcel(formbody):any {
    return this.http.post(environment.ApiUrl + '/api/Client-Instructions-Export-Excel', formbody, {responseType: 'blob'})
        .pipe(map(res => {
    return {
        filename: 'Client Instruction.xlsx',
        data: res
    };
    }))
  }
}
